import styled from 'styled-components';

export const Container = styled.form`
  width: 100%;
  max-width: 335px;
  height: auto;
  display: flex;
  flex-direction: column;
  align-items: center;
  background-color: ${props => props.theme['app-background-color']};
  justify-content: flex-start;
  overflow-y: auto;
  overflow-x: hidden;
  align-self: center;
  align-items: center;
  @media (max-width: 500px) {
    height: 100%;
  }
`;

export const Image = styled.img`
  width: 26.67vw;
  height: 26.67vw;
`;

export const Header = styled.div`
  font-family: PublicSans-SemiBold;
  font-size: 7.2vw;
  color: #111010;
  letter-spacing: -0.45px;
  text-align: center;
  max-height: 26.87vw;
  display: flex;
  align-items: center;
  justify-content: center;
  min-height: 14vw;
  max-height: 29vw;
  flex: 1;
`;
